<template>
  <VTBaseTemplate>
    <!-- MODALS -->
      <b-modal
        id="api-err-modal"
        v-model="apiErrModalShow"
        centered
        scrollable
        hide-footer
        hide-header-close
        no-close-on-backdrop
        no-close-on-esc
        title="Dataset Fetch Error"
        :header-bg-variant="'warning'"
        :header-text-variant="'light'">
        <span v-html="err_msg"></span>
        <b-button 
          class="mt-3" 
          :to="{name: 'vectraits-explorer'}" 
          block
        >OK</b-button>
      </b-modal>

      <b-modal
        id="doi-err-modal"
        v-model="doiErrModalShow"
        centered
        scrollable
        hide-footer
        hide-header-close
        no-close-on-backdrop
        no-close-on-esc
        title="DOI Format is Invalid"
        :header-bg-variant="'warning'"
        :header-text-variant="'light'">
        <span v-html="err_msg"></span>
        <b-button class="mt-3" @click="hideDoiModal" block>Cancel</b-button>
        <b-button class="mt-3" @click="editCitation(); hideDoiModal();" block>Submit changes anyway</b-button>
      </b-modal>
      <b-modal
        v-model="embargoKeyModalShow"
        centered
        scrollable
        hide-footer
        title="Reset Embargo Key"
        :header-bg-variant="'warning'"
        :header-text-variant="'light'"
      >
        <p>
          Are you sure you want to reset the Embargo Key for this dataset?<br>
          Note that any links previously shared will no longer work once the Embargo Key is reset.
        </p>
        <b-button class="mt-3" style="margin-right:20px; margin-left:100px;" @click="embargoKeyModalShow=false">
          Cancel
        </b-button>
        <b-button class="mt-3" variant='primary' @click="resetEmbargoKey">Reset Embargo Key</b-button>
      </b-modal>
      <!-- END MODALS -->
    <div class="w-100 h-100">
      <b-container fluid>
        <br><br><br>
        <h2 class="tw-mb-0 text-aegis-dk">Citation for Dataset: {{ id }}</h2>
      </b-container>
      <hr />
      <b-container 
        fluid 
        style="color: black; text-align: left; padding-left: 50px; padding-right: 50px;" 
        class="data-table" 
        v-if="data"
      >
        <b-row>
          <b-col md="12">
            <div class="well">
              <h3>Citation Number: {{ citationid }}</h3>
              <form @submit.prevent="onSubmit" class="mt-3">
                <fieldset >
                  <div class="row mb-3">
                    <label class="col-sm-2 control-label col-form-label">URL with Embargo Link</label>
                    <div class="col-sm-10">
                      <b-row>
                      <b-col cols="9" class="mt-2">
                        https://vectorbyte.crc.nd.edu/vectraits-dataset/{{ id }}/{{ embargo_key }}
                      </b-col>
                      <b-col cols="3">
                        <b-button 
                          variant="primary" 
                          @click="embargoKeyModalShow = true"
                          style="font-size: small; float: right;"
                        >Reset Embargo Key</b-button>
                      </b-col>
                      </b-row>
                      </div>
                    </div>
                  <div class="row mb-3">
                    <label class="col-sm-2 control-label col-form-label">Citation</label>
                    <div class="col-sm-10">
                      <input v-model="citation" class="form-control" type="text">
                    </div>
                  </div>
                  <div class="row mb-3">
                    <label class="col-sm-2 control-label col-form-label">Doi</label>
                    <div class="col-sm-10">
                      <input v-model="doi" name="doi" class="form-control" type="text" >    
                    </div>
                  </div>
                  <!-- COMMENTED OUT - Keep for potential future use -->
                  <!-- <div class="row mb-3">
                    <label class="col-sm-2 control-label col-form-label">Original Trait Name</label>
                    <div class="col-sm-10">
                      <input v-model="originaltraitname" class="form-control" type="text">
                    </div>
                  </div>
                  <div class="row mb-3">
                    <label class="col-sm-2 control-label col-form-label">Second Stressor</label>
                    <div class="col-sm-10">
                      <input v-model="secondstressor" class="form-control" type="text">
                    </div>
                  </div>
                  <div class="row mb-3">
                    <label class="col-sm-2 control-label col-form-label">Original Trait Definition</label>
                    <div class="col-sm-10">
                      <textarea v-model="originaltraitdef" class="form-control" rows="3"></textarea>
                    </div>
                  </div>
                  <div class="row mb-3">
                    <label class="col-sm-2 control-label col-form-label">Standardised Trait Name</label>
                    <div class="col-sm-10">
                      <input v-model="standardisedtraitname" class="form-control" type="text">
                    </div>
                  </div>
                  <div class="row mb-3">
                    <label class="col-sm-2 control-label col-form-label">Standardised Trait Definition</label>
                    <div class="col-sm-10">
                      <textarea v-model="standardisedtraitdef" class="form-control" rows="3"></textarea>
                    </div>
                  </div> -->
                  <div class="row mb-3">
                    <label class="col-sm-2 control-label col-form-label">Tag(s)</label>
                    <div class="col-sm-10">
                      <!-- Tags display and input -->
                      <div class="tags-container">
                        <!-- Display existing tags -->
                        <div v-if="tags && tags.length > 0" class="mb-2">
                          <span 
                            v-for="(tag, index) in tags" 
                            :key="index" 
                            class="badge badge-primary mr-1 mb-1"
                            style="font-size: 0.8em; cursor: pointer;"
                            @click="removeTag(index)"
                            title="Click to remove"
                          >
                            {{ tag }} ×
                          </span>
                        </div>
                        <!-- Input for new tag -->
                        <div class="input-group">
                          <input 
                            v-model="newTag" 
                            class="form-control" 
                            type="text" 
                            placeholder="Enter a tag and press Enter"
                            @keydown.enter.prevent="addTag"
                            @keydown="handleKeydown"
                          >
                          <div class="input-group-append">
                            <button 
                              class="btn btn-outline-secondary" 
                              type="button" 
                              @click="addTag"
                              :disabled="!newTag.trim()"
                            >
                              Add Tag
                            </button>
                          </div>
                        </div>
                        <small class="form-text text-muted">
                          Press Enter or comma to add a tag. Click on a tag to remove it.
                        </small>
                      </div>
                    </div>
                  </div>
                  <div class="row mb-3">
                    <label class="col-sm-2 control-label col-form-label">Curated By Citation</label>
                    <div class="col-sm-10">
                      <textarea v-model="curatedbycitation" class="form-control" rows="2" placeholder="Citation of the curation project"></textarea>
                      <small class="form-text text-muted">
                        Citation information for the curation project (if applicable)
                      </small>
                    </div>
                  </div>
                  <div class="row mb-3">
                    <label class="col-sm-2 control-label col-form-label">Curated By DOI</label>
                    <div class="col-sm-10">
                      <input v-model="curatedbydoi" class="form-control" type="text" placeholder="DOI of the curation project">
                      <small class="form-text text-muted">
                        DOI for the curation project (if applicable)
                      </small>
                    </div>
                  </div>
                  <!-- COMMENTED OUT - Keep for potential future use -->
                  <!-- <div class="row mb-3 horizontal-checkbox ">
                    <label class="col-sm-2 control-label col-form-label">Published</label>
                    <div class="col-sm-10">
                      <input v-model="published" type="checkbox" name="published" >
                    </div>
                  </div> -->
                  <div class="row mb-3">
                    <label class="col-sm-2 control-label col-form-label">Embargorelease</label>
                    <div class="col-sm-10">
                      <input v-model="embargorelease" name="embargorelease" class="form-control" type="date">
                    </div>
                  </div>
                  <div class="form-actions">
                    <router-link 
                      :to="{ name: 'vectraits-dataset', params: { id: this.id } }" 
                      class="btn btn-primary js-tooltip ml-1 button-link" 
                      style="float: right;"
                    >
                      Return to Dataset
                    </router-link>

                    <button 
                      type="submit"
                      class="btn btn-primary js-tooltip ml-1"
                      style="float: right;"
                      :class="{ 'btn-warning': hasUnsavedChanges }"
                      :title="hasUnsavedChanges ? 'You have unsaved changes' : ''"
                    >
                      {{ hasUnsavedChanges ? 'Save Changes *' : 'Save Changes' }}
                    </button>
                  </div>
                  
                </fieldset>
              </form>
            </div>
          </b-col>
        </b-row>
      </b-container>
    </div>
  </VTBaseTemplate>
</template>

<script>
// import { HTTP, DOI_URL } from "@/utilities/http-common";
import { HTTP } from "@/utilities/http-common";
import HandleErrors from "@/utilities/handle-errors";
import VTBaseTemplate from "@/layouts/VTBaseTemplate.vue";

export default {
  name: "citation-edit",
  mixins: [VTBaseTemplate],
  components: {
      VTBaseTemplate,
  },
  props: {
    id: {
      type: String,
      required: true
    },
  },
      data(){
        return{
          data: undefined,
          embargo_key: '',
          citationid: '',
          citation: '',
          doi: '',
          tags: [],
          newTag: '',
          // published: '',  // COMMENTED OUT - Keep for potential future use
          embargorelease: '',
          // VecTraitsDataset fields - COMMENTED OUT for now, keep for potential future use
          // originaltraitname: '',
          // secondstressor: '',
          // originaltraitdef: '',
          // standardisedtraitname: '',
          // standardisedtraitdef: '',
          curatedbycitation: '',
          curatedbydoi: '',
          err_msg: '',
          apiErrModalShow: false,
          doiErrModalShow: false,
          embargoKeyModalShow: false,
          // Store original values for change tracking
          originalData: {},
        };
      },
  computed: {
    // Check if there are any unsaved changes
    hasUnsavedChanges() {
      const changedFields = this.getChangedFields();
      return Object.keys(changedFields).length > 0;
    }
  },
  watch: {},
  created() {
    document.title = "Citation for Dataset " + this.id;
    this.getData();
    this.getEmbargoKey();
  },
  methods: {
    hideDoiModal() {
      this.doiErrModalShow = false;
    },
    // Tag management methods
    addTag() {
      const tag = this.newTag.trim();
      if (tag && !this.tags.includes(tag)) {
        this.tags.push(tag);
        this.newTag = '';
      }
    },
    removeTag(index) {
      this.tags.splice(index, 1);
    },
    handleKeydown(event) {
      if (event.key === ',') {
        event.preventDefault();
        this.addTag();
      }
    },
    // Store original data for change tracking
    storeOriginalData() {
      this.originalData = {
        citation: this.citation,
        doi: this.doi,
        tags: JSON.parse(JSON.stringify(this.tags)), // Deep copy of array
        // published: this.published,  // COMMENTED OUT
        embargorelease: this.embargorelease,
        // VecTraitsDataset fields - COMMENTED OUT for now
        // originaltraitname: this.originaltraitname,
        // secondstressor: this.secondstressor,
        // originaltraitdef: this.originaltraitdef,
        // standardisedtraitname: this.standardisedtraitname,
        // standardisedtraitdef: this.standardisedtraitdef,
        curatedbycitation: this.curatedbycitation,
        curatedbydoi: this.curatedbydoi,
      };
    },
    // Get only changed fields
    getChangedFields() {
      const changedFields = {};
      
      // Helper function to compare values (handles arrays and null/undefined)
      const hasChanged = (current, original) => {
        if (Array.isArray(current) && Array.isArray(original)) {
          return JSON.stringify(current.sort()) !== JSON.stringify(original.sort());
        }
        return current !== original;
      };
      
      // Check each field for changes
      const fieldsToCheck = [
        'citation', 'doi', /* 'published', */ 'embargorelease',
        // COMMENTED OUT - keep for potential future use:
        // 'originaltraitname', 'secondstressor', 'originaltraitdef',
        // 'standardisedtraitname', 'standardisedtraitdef',
        'curatedbycitation', 'curatedbydoi'
      ];
      
      fieldsToCheck.forEach(field => {
        if (hasChanged(this[field], this.originalData[field])) {
          changedFields[field] = this[field];
        }
      });
      
      // Handle tags separately since it's an array
      if (hasChanged(this.tags, this.originalData.tags)) {
        changedFields.tags = this.tags;
      }
      
      return changedFields;
    },
    getData() {
      // Get both citation and VecTraitsDataset data in one call
      return HTTP.get(`/api/vectraits-get-dataset/${this.id}/`)
      .then(response => {
        this.data = response.data.results;
        this.citation = response.data.results['citation'];
        this.doi = response.data.results['doi'];
        // Handle tags as array - ensure it's always an array
        this.tags = Array.isArray(response.data.results['tags']) ? response.data.results['tags'] : [];
        // this.published = response.data.results['published'];  // COMMENTED OUT
        this.embargorelease = response.data.results['embargorelease'];
        this.citationid = response.data.results['citationid'];
        // VecTraitsDataset fields - COMMENTED OUT for now
        // this.originaltraitname = response.data.results['originaltraitname'];
        // this.secondstressor = response.data.results['secondstressor'];
        // this.originaltraitdef = response.data.results['originaltraitdef'];
        // this.standardisedtraitname = response.data.results['standardisedtraitname'];
        // this.standardisedtraitdef = response.data.results['standardisedtraitdef'];
        this.curatedbycitation = response.data.results['curatedbycitation'] || '';
        this.curatedbydoi = response.data.results['curatedbydoi'] || '';
        
        // Store original values for change tracking
        this.storeOriginalData();
      })
      .catch(error => {
        this.err_msg = HandleErrors.HandleErrors(error);
        this.apiErrModalShow = true;
      });
    },
    onSubmit(){
      this.editCitation()
      // this.formData = new FormData();
      // // check format of doi
      // DOI_URL.get(`/${this.doi}`)
      // .then(() => {
      //   this.editCitation()
      // }).catch(error => {
      //   this.err_msg = HandleErrors.HandleErrors(error);
      //   this.doiErrModalShow = true;
      // });
    },
    getEmbargoKey() {
      return HTTP.get(`/api/vectraits-get-embargo-key/${this.id}`)
      .then(response => {
        this.embargo_key = response.data['embargo_key'];
      })
      .catch(error => {
        this.err_msg = HandleErrors.HandleErrors(error);
        this.apiErrModalShow = true;
      });
    },
    resetEmbargoKey() {
      return HTTP.get(`/api/vectraits-reset-embargo-key/${this.id}`)
      .then(response => {
        this.embargo_key = response.data['embargo_key'];
        this.embargoKeyModalShow = false;
      })
      .catch(error => {
        this.err_msg = HandleErrors.HandleErrors(error);
        this.embargoKeyModalShow = false;
        this.apiErrModalShow = true;
      });
    },
    editCitation() {
      // Get only the fields that have changed
      const changedFields = this.getChangedFields();
      
      // Check if there are any changes
      if (Object.keys(changedFields).length === 0) {
        this.$notify({
          text: "No changes detected. Nothing to save.",
          duration: 5000,
          type: "info",
        });
        return;
      }
      
      // Prepare JSON payload with only changed fields (use PATCH for partial updates)
      const payload = {};
      
      // Add changed fields to payload
      Object.keys(changedFields).forEach(field => {
        const value = changedFields[field];
        // Handle tags as array (Django expects array, not JSON string)
        if (field === 'tags') {
          payload.tags = value; // Send as array directly
        } else {
          payload[field] = value;
        }
      });

      // Remove null values from payload
      Object.keys(payload).forEach(key => {
        if (payload[key] === null || payload[key] === undefined) {
          delete payload[key];
        }
      });

      // Use the new VecTraitsDataset edit endpoint
      HTTP.patch(`/api/vectraits-edit-dataset/${this.id}/`, payload, {
        headers: {
          'Content-Type': 'application/json'
        }
      })
        .then(response => { 
          this.err_msg = response.data.err_msg;
          this.$notify({
            text: "Citation successfully updated!",
            duration: 10000,
            type: "success",
          });
          // Update original data after successful save
          this.storeOriginalData();
      })
      .catch(error => {
          this.err_msg = HandleErrors.HandleErrors(error);
          this.apiErrModalShow = true;
      });
    },
  },
};
</script>

<style scoped>
    h1, h2, h3, h4, a, p, text, label, table {
        color: black !important;
        text-shadow: none;
    }

    .button-link {
      color: white !important;
    }

    .data-table .data-table-row:nth-child(even){
        background-color: #CFD5E9;
    }
    .data-table .data-table-row:nth-child(odd){
        background-color: #E9EBF4;
    }
    .data-table .data-table-row{
        border-top: 2px solid white;
    }

    .unplottable {
      color: red !important;
    }

    .vertical-center {
      margin: 0;
      position: absolute;
      top: 50%;
      -ms-transform: translateY(-50%);
      transform: translateY(-50%);
    }

    .well {
      min-height: 20px;
      padding: 19px;
      margin: 6px;
      margin-bottom: 20px;
      background-color: #f5f5f5;
      border: 1px solid #e3e3e3;
      border-radius: 4px;
    }

    /* Tags styling */
    .tags-container .badge {
      display: inline-block;
      padding: 0.25em 0.4em;
      font-size: 0.75em;
      font-weight: 700;
      line-height: 1;
      text-align: center;
      white-space: nowrap;
      vertical-align: baseline;
      border-radius: 0.25rem;
      background-color: #007bff;
      color: #fff;
      transition: background-color 0.15s ease-in-out;
    }

    .tags-container .badge:hover {
      background-color: #dc3545;
    }

    .tags-container .input-group {
      margin-top: 0.5rem;
    }

</style>